import React from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';

function ProtectedRoute({}) {
  const user = JSON.parse(localStorage.getItem('user'));
  const location = useLocation();


  // إذا لم يتم تسجيل الدخول
  if (!user || user?.cln_isverificated?.trim() =="0") {
    return <Navigate to="/login" />;
  }


  return <Outlet />;
}

export default ProtectedRoute;
